const ReportTemplateGroupCalculation = (data) => {
  const { group_data, group_label, key, list_data, report_type } = data;

  data.group_count = list_data.length;

  return data;
};

export default ReportTemplateGroupCalculation;
